import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchRejectionRequest } from '../../../api/dashboard/dashboardSlice';
import { Box, Grid, Paper, Typography } from '@mui/material';
import TimeRangeSelector from './TimeRangeSelector';
import TopRejectionsTable from './TopRejectionTable';

const RejectionSection = () => {
  const dispatch = useDispatch();
  const { rejectionData, loading, error } = useSelector((state) => state.dashboard);
  const [timeRange, setTimeRange] = useState('week');

  useEffect(() => {
    const { startDate, endDate } = getDateRange(timeRange);
    dispatch(fetchRejectionRequest({ startDate, endDate }));
  }, [timeRange, dispatch]);

  const handleTimeRangeChange = (event) => {
    setTimeRange(event.target.value);
  };

  const getDateRange = (range) => {
    const now = new Date();
    const endDate = now.toISOString().split('T')[0];

    let startDate = new Date(now);

    switch (range) {
      case 'week':
        startDate.setDate(now.getDate() - 7);
        break;
      case 'month':
        startDate.setMonth(now.getMonth() - 1);
        break;
      case 'quarter':
        startDate.setMonth(now.getMonth() - 3);
        break;
      default:
        startDate.setDate(now.getDate() - 7);
    }

    startDate = startDate.toISOString().split('T')[0];

    return { startDate, endDate };
  };

  if (error)
    return (
      <Paper elevation={3} sx={{ p: 3, bgcolor: '#fff4f4' }}>
        <Typography color="error" variant="h6">
          Error: {error}
        </Typography>
      </Paper>
    );

  if (!rejectionData) return null;

  return (
    <Box sx={{ p: 2 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 3 }}>
        <Typography variant="h5" sx={{ fontWeight: 'bold' }}>
          Rejection Analysis
        </Typography>
        <TimeRangeSelector timeRange={timeRange} handleTimeRangeChange={handleTimeRangeChange} loading={loading} />
      </Box>
      <Grid size={{ xs: 12, md: 6 }}>
        <TopRejectionsTable rejections={rejectionData} loading={loading} />
      </Grid>
    </Box>
  );
};

export default RejectionSection;
